import apiUrl from '../../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import vSelect from 'vue-select'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Loader from './../../shared/loader'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import download from 'downloadjs';
import { BasicSelect } from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel)
export default {
	name: 'stockenquiry',
	components: {
		BasicSelect,
		Loader,
		JsonExcel,
		download,
	},
	props: [],
	data() {
		return {
			selectedmerchant:{value:'',text:''},
			merchantList:[],
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listStockReportDataforxls: [],
			listStockReportDatacsv: [],
			productid: '',
			mrp: '',
			lotno: '',
			rackid: '',
			ProductName: '',
			ProductDescription: '',
			listsubinventoryData: [],
			subinventory: '',
			TotalStock: '',
			RackNo: '',
			isfoundID: '',
			isnotfoundID: '',
			isError: '',
			IDerrors: '',
			listData: [],
			stockerrors: '',
			listClientData: [],
			listWarehouseData: [],
			listMerchantData: [],
			warehouse: '',
			merchant: '',
			client: '',
			ClientErr: '',
			WarehouseErr: '',
			MerchantErr: '',
			MRPErr: '',
			ClientErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant:false,
			formattedDate: '',
			isLoading: false,
			user_type: '',
			stocktype: '',
			stocktypeErr: '',
			showOrderAllocationRacks: false,
			flag: false,
			allocationResultData: [],
			clientid:'',
			warehouseid:'',
			activemrpflag:false,
			isInventoryZone:false,
			zonename:''
		}
	},
	model: {
		totalCurrentStock: 0,
		totalRackStock: 0
	},
	computed: {
		totalCurrentStock: function() {
			return this.listData.reduce(function(totalCurrentStock, item) {
				return totalCurrentStock + parseFloat(item.whcurrentstock);
			}, 0);
		},
		totalRackStock: function() {
			return this.listData.reduce(function(totalRackStock, item) {
				return totalRackStock + parseFloat(item.whrackstock);
			}, 0);
		}
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},


	mounted() {
		this.warehouseid = '';
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyID = userdetail.warehouseid;
		this.reportname = this.$t('reports.stockEnquiry');
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if(this.clientid!=='undefined'){
			this.getMerchantList();
			this.getsubinventoryList();
			// this.subinventory();
		}
		if(this.clientid!=='undefined' && this.warehouseid!=='undefined'){
			this.getInventoryZonePermission();
		}
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant =true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
			    this.getMerchantList();
				this.getActiveMrpFlag();
				this.showSelectWarehouse = true;
				this.showSelectMerchant =true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant =true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			if(window.localStorage.getItem('selectedWarehouse')!=='undefined'){
			  this.getInventoryZonePermission();
			}
		  });

	},
	methods: {
		selectMerchant(data){
			this.selectedmerchant = data;
			this.merchant = data.value;
		  },
		isNumeric: function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		},
		test() {

		},
		Choosetype() {
			this.isfoundID = '1'
			this.show = true;
			this.download = false;
			this.SearchProductForXls(3)
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'

			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function(item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		resetFlt() {
			//	this.$validator.reset();
			this.WarehouseErr = '';
			this.ClientErr = '';
			this.show = false;
			this.download = true;
			this.stocktypeErr = '';
			this.isfoundID = '';
			this.ClientErr = '';
			this.MerchantErr = '';
			this.merchant = '';
			this.MRPErr = '';
			this.subinventory = '';
			this.flag = false;
		    this.selectedmerchant={}
			this.zonename=''
			// if (this.user_type != "warehouse_user") {
			// 	this.WarehouseErr = "";
			// 	this.warehouse = "";
			// }
			// if  (this.user_type != "client_user"){
			// 	this.client = "";
			// 	// this.merchantList=[]
			// }
			this.IDerrors = "";

			this.productid = "";
			document.getElementById("productid").value = "";
			this.mrp = "";
			document.getElementById("mrp").value = "";
			this.lotno = "";
			document.getElementById("lotno").value = "";
			this.rackid = "";
			document.getElementById("rackid").value = "";
			this.stocktype = "";
			this.listData = [];
			this.stockerrors = "";
		},
		getsubinventoryList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.client,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSubInventoryList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listsubinventoryData = result.data;

					}
				}, error => {
					console.error(error)
				})
		},
		async getInventoryZonePermission(){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input=({
				clientid:window.localStorage.getItem("selectedClient"),
				warehouseid:window.localStorage.getItem("selectedWarehouse"),
			})
			const result=await axios({
				method:'POST',
				'url':apiUrl.api_url+'getInventoryZonePermission',
                'data':this.input,
				headers:{
					'Authorization':'Bearer '+myStr
				}
			})
			try{
			   this.isInventoryZone=result.data.inventoryZoneStatus
			}catch(error){
				console.error(error)
			}
		},

		getMerchantList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;

						this.merchantList.push({
							value:'',text: this.$t('common.selectMerchantPlaceHolder')}
					   )
						for (var i = 0; i < this.listMerchantData.length; i++) {
							// console.log( this.listMerchantData.merchantname[i],"merchname")
							this.merchantList.push({
							  'value': this.listMerchantData[i].merchantid,
							  'text': this.listMerchantData[i].merchantname
							});
						  }

					}
				}, error => {
					console.error(error)
				})
		},
		async getActiveMrpFlag(){
				 var userToken = window.localStorage.getItem('userToken');
				 var myStr = userToken.replace(/"/g, '');
				 this.input = ({
					 "clientid": this.clientid,
				 });
			 try {

					 axios({
							 method: 'POST',
							 'url': apiUrl.api_url + 'checkActivemrpFlg',
							 'data': this.input,
							 headers: {
								 'Authorization': 'Bearer ' + myStr,
							 }
						 })
						 .then(result => {
							 if(result.data.data.data[0].value ==='yes'){
								 this.activemrpflag = true;
							 }else{
								 this.activemrpflag = false;
							 }
						 }, error => {
							 console.error(error);
						 });

				 } catch (err) {
					 throw new Error(err);
				 }
	 },
		SearchProduct(csvCheck = 0) {
			this.isfoundID = '';
			this.isnotfoundID = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			var mrpPost = 0;

			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.listData = [];
				return false;
			}
			if (this.productid == '') {
				this.isError = '1';
				this.IDerrors = this.$t('common.productIdError');
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.listData = [];
				return false;
			}
			if (this.stocktype == '') {
				this.stocktypeErr =  this.$t('common.stockTypeRequired');
				this.pageNo = this.pageCount = 0;
				this.listData = [];
				return false;
			}
			if (this.mrp != '') {
				if (this.isNumeric(this.mrp)) {
					console.log(this.mrp);
					var mrpPost = this.mrp;
					this.flag = false;
				} else {
					this.MRPErr = this.$t('srqc.numberMrpError');
					this.flag = true;
					this.listData = [];
					return false;
				}


			}


			this.isLoading = true;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'productid': this.productid,
				'mrp': mrpPost,
				'lotno': this.lotno.trim(),
				'rackid': this.rackid,
				'warehouseid': this.createdbyID,
				'clientid': window.localStorage.getItem('selectedClient'),
				'warehouseid': window.localStorage.getItem('selectedWarehouse'),
				'stocktype': this.stocktype,
				'subinventory': this.subinventory,
				'csvData': csvCheck,
				'merchantid': this.merchant,
				'zonename':this.zonename
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductEnquiry',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (csvCheck == 1) {
						if (response.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listStockReportDataCsv = [];

							this.csvFields = {
								'rackid': this.$t('common.rackID'),
								'mrp': this.$t('common.mrp'),
								'activemrp': this.$t('common.activemrp'),
								'whcurrentstock': this.$t('printProductDetails.currentStock'),
								'whrackstock':  this.$t('reports.rackStock'),
								'lotno':  this.$t('reports.lotNo'),
								'expirydate': this.$t('common.expiryDate'),
								'subinventory': this.$t('reports.inventory'),
								'racktype': this.$t('common.stockTypeField'),
								'eancode': this.$t('common.eanCode'),
								'productid': this.$t('common.productId'),
								'rackno': this.$t('warehouseRacks.rackNo'),
								'merchantname': this.$t('common.merchant'),
								'productdescription': this.$t('common.productDescription'),
								'productname':  this.$t('common.productName'),
								'totalstock': this.$t('activities.totalStock'),
								'lotcontrol': this.$t('reports.lotControl'),
								'zonename':this.$t('common.zoneName')


							};
							var dateFilder = [];
							if(this.activemrpflag === true){
								var skipFilter = [];
							}else {
								var skipFilter = ['activemrp'];
							}

							if(this.isInventoryZone===false){
								skipFilter.push('zonename')
							}
							this.listStockReportDataCsv = response.data.data;
							this.jsonToCSV(this.$t('reports.stockEnquiry'), this.listStockReportDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					}
					if (response.data.errorCode == 0) {
						this.listData = response.data.data;
						this.isfoundID = '1';
						this.isnotfoundID = '';
						this.isError = '';
						this.IDerrors = '';
						this.ClientErr = '';
						this.stockerrors = '';
					} else {
						this.isnotfoundID = '1';
						this.isfoundID = '';
						this.isError = '1';
						this.stockerrors = response.data.msg;
					}
					this.isLoading = false;
				})

		},
		SearchProductForXls(csvCheck = 0) {

			this.isnotfoundID = '';
			this.isfoundID = '1'
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			var mrpPost = 0;

			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.listData = [];
				return false;
			}

			if (this.productid == '') {
				this.isError = '1';
				this.IDerrors = this.$t('consolidation.productIdRequiredErr');
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.listData = [];
				return false;
			}
			if (this.stocktype == '') {
				this.stocktypeErr = this.$t('common.stockTypeRequired');
				this.pageNo = this.pageCount = 0;
				this.listData = [];
				return false;
			}
			if (this.mrp != '') {
				if (this.isNumeric(this.mrp)) {
					console.log(this.mrp);
					var mrpPost = this.mrp;
					this.flag = false;
				} else {
					this.MRPErr =this.$t('srqc.numberMrpError');
					this.flag = true;
					this.listData = [];
					return false;
				}


			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				'productid': this.productid,
				'mrp': mrpPost,
				'lotno': this.lotno.trim(),
				'rackid': this.rackid,
				'warehouseid': this.createdbyID,
				'clientid': window.localStorage.getItem('selectedClient'),
				'warehouseid': window.localStorage.getItem('selectedWarehouse'),
				'stocktype': this.stocktype,
				'subinventory': this.subinventory,
				'csvData': csvCheck,
                'zonename':this.zonename
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getProductEnquiry',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (csvCheck == 3) {
						if (response.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('common.rackID')]='rackid';
							this.csvFieldsForXls[this.$t('common.mrp')]='mrp';
							if(this.activemrpflag === true){
								this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
							}
							this.csvFieldsForXls[this.$t('printProductDetails.currentStock')]='whcurrentstock';
							this.csvFieldsForXls[this.$t('reports.rackStock')]='whrackstock';
							this.csvFieldsForXls[this.$t('reports.lotNo')]='lotno';
							this.csvFieldsForXls[this.$t('common.expiryDate')]='expirydate';
							this.csvFieldsForXls[this.$t('reports.inventory')]='subinventory';
							this.csvFieldsForXls[this.$t('common.merchant')]='merchantname';
							this.csvFieldsForXls[this.$t('common.stockTypeField')]='racktype';
							this.csvFieldsForXls[this.$t('common.eanCode')]='eancode';
							this.csvFieldsForXls[this.$t('common.productId')]='productid';
							this.csvFieldsForXls[ this.$t('warehouseRacks.rackNo')]='rackno';
							this.csvFieldsForXls[this.$t('common.productDescription')]='productdescription';
							this.csvFieldsForXls[this.$t('common.productName')]='productname';
							this.csvFieldsForXls[this.$t('activities.totalStock')]='totalstock';
							if(this.isInventoryZone === true){
                            	this.csvFieldsForXls[this.$t('common.zoneName')]='zonename';
							}
							this.listStockReportDataforxls = response.data.data;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}

				})

		},
		// getClientList() {
		// 	this.listClientData = '';
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	this.clientid = this.client;
		// 	this.merchant = '';
		// 	if (this.clientid) {
		// 		this.merchantList=[]
		// 		this.selectedmerchant={}
		// 		this.getsubinventoryList();
		// 		this.getMerchantList();
		// 		this.getActiveMrpFlag();
		// 		this.merchant='';
		// 		if(this.user_type!="warehouse_user"){
		// 			this.warehouse='';
		// 			this.getWarehouseList();
		// 		}
		// 		if (this.warehouseid) {
		// 			// this.SearchProduct();
		// 		} else {
		// 			//this.merchantList=[]
		// 			this.selectedmerchant={}
		// 			this.getWarehouseList();
		// 			this.getsubinventoryList();
		// 			//this.getMerchantList();
		// 		}
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.SearchProduct();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },


		viewRackDetails(rackid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.showOrderAllocationRacks = true;
			this.isLoading = true;

			if (this.clientid == '') {
				this.ClientErr = this.$t('srReport.clientError');
				return false;
			}
			if (this.warehouseid == '') {
				this.ClientErr = this.$t('common.warehouseError');
				return false;
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getStockAllocationForProduct',
					'data': {
						clientid: window.localStorage.getItem('selectedClient'),
						warehouseid: window.localStorage.getItem('selectedWarehouse'),
						rackid: rackid,
						productid: this.listData[0].productid,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.allocationResultData = result.data.data;
					this.isLoading = false;
				}, error => {
					console.error(error);
				});
		},
		// onSubmitForm: function() {
		// 	this.$validator.validateAll().then(() => {
		// 		console.log('form is valid')
		// 	}).catch(() => {
		// 		console.log('errors exist')
		// 	});
		// },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/stockenquiry/stockenquiry.component.js